import { Icon } from '@benzinga/core-ui';
import { MenuNodeDef } from '@benzinga/widget-tools';
import { ProContextProps } from '@benzinga/pro-tools';
import { faGrid2Plus } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import { Newsfeed, Details, Calendar, Signals, Candlestick } from '@benzinga/themed-icons';

export const openWithContextOption = (
  ticker: string,
  addWidgetWithSymbol: ProContextProps['addWidgetWithSymbol'],
): MenuNodeDef => {
  const widgets = [
    {
      icon: <Newsfeed />,
      name: 'Newsfeed',
      type: 'advancedNewsfeed',
    },
    {
      icon: <Details />,
      name: 'Details',
      type: 'details',
    },
    {
      icon: <Calendar />,
      name: 'Market Events',
      type: 'calendar',
    },
    {
      icon: <Signals />,
      name: 'Signals',
      type: 'signals',
    },
    {
      icon: <Candlestick />,
      name: 'Chart',
      type: 'chart',
    },
  ];

  const widgetNodes = widgets.flatMap<MenuNodeDef>(widget => ({
    action: () => addWidgetWithSymbol(ticker, widget.type),
    icon: widget.icon,
    key: widget.type,
    name: widget.name,
    type: 'Item',
  }));

  return {
    icon: (<Icon icon={faGrid2Plus} />) as React.ReactElement,
    key: 'openWith',
    name: 'Open With',
    nodes: widgetNodes,
    type: 'SubMenu',
  };
};
